import React, { useEffect, useState } from "react";
import ModalHeader from "../../shared/components/ModalHeader";
import gettext from "../../shared/utils/gettext";
import { Modal } from "react-bootstrap";
import { Model } from "backbone";
import cropr from "../../shared/utils/cropr";
// @ts-ignore
import MultiSelect from "@kenshooui/react-multi-select";
import "@kenshooui/react-multi-select/dist/style.css";

type SortedListData = {
  id: string;
  label: string;
};

export type PriorityMeasurementsProps = {
  machine: Model;
  selected: string;
  onChange: any;
};

const PriorityMeasurementsSelectModal = ({
  machine,
  selected,
  onChange = () => {},
}: PriorityMeasurementsProps) => {
  const [showModal, setShowModal] = useState(false);
  const [noMeasurements, setNoMeasurements] = useState(selected === "-");
  const [measurements, setMeasurements] = useState<SortedListData[]>([]);
  const [selectedMeasurements, setSelectedMeasurements] = useState<SortedListData[]>([]);
  useEffect(() => {
    const url = `${cropr.cloudfarm_domain}/api/data/datasets/elasticsearch/_search`;
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        post_filter: {
          bool: {
            should: [
              {
                term: {
                  "dataset_measurements.device.keyword": machine.get("serial_number"),
                },
              },
              {
                term: {
                  "dataset_measurements.device.keyword": machine.get("serial_number").toUpperCase(),
                },
              },
              {
                term: {
                  "dataset_measurements.device.keyword": machine.get("serial_number").toLowerCase(),
                },
              },
            ],
          },
        },
        size: 1,
        sort: [
          {
            created: "desc",
          },
        ],
      }),
      headers: {
        Authorization: `Bearer ${cropr.cloudfarm_oauth_token}`,
        "Content-Type": "application/json",
      },
    }).then((response: { ok: any; json: () => Promise<any> }) => {
      if (response.ok) {
        response.json().then((result: any) => {
          const items: { id: any; label: any }[] = [];
          result.hits.hits.forEach((h: any) => {
            h._source.dataset_measurements.forEach((m: any) => {
              if (
                (m.device &&
                  m.device.toLowerCase() === machine.get("serial_number").toLowerCase()) ||
                m.device === machine.get("name")
              ) {
                const normalizedName = m.name.toLowerCase().split("__")[0];
                if (!items.find((i) => i.id === normalizedName)) {
                  // @ts-ignore
                  const mtype = cropr.isobus_measurement_types[m.name];
                  const label = `${mtype?.name || m.name} ${m.unit ? `(${m.unit})` : ""}`;
                  items.push({ id: normalizedName, label: label });
                }
              }
            });
          });
          setMeasurements(items);
        });
      }
    });
  }, [setMeasurements, machine]);
  useEffect(() => {
    const selectedM: SortedListData[] = [];
    measurements.forEach((m) => {
      if (selected.indexOf(m.id) >= 0) {
        selectedM.push(m);
      }
    });
    setSelectedMeasurements(selectedM);
  }, [setSelectedMeasurements, measurements, selected]);

  const closeModal = () => {
    setShowModal(false);
  };

  const onChangeNoMeasurement = (checked: boolean) => {
    setNoMeasurements(checked);
    if (checked) {
      onChange("-");
    } else {
      onChange(selectedMeasurements.map((m) => m.id).join(","));
    }
  };

  return (
    measurements.length > 0 && (
      <>
        <h4 className="mt-3">{gettext("Measurements")}</h4>
        {gettext(
          "Configure the measurements from this machine you want to see immediately in Cloudfarm"
        )}
        <button
          className="btn btn-outline-smoke d-block mb-2 mt-1"
          onClick={() => setShowModal(true)}
        >
          {gettext("Click to change")}
        </button>
        <ul>
          {!noMeasurements && selectedMeasurements.map((m) => <li key={m.id}>{m.label}</li>)}
          {!noMeasurements && selectedMeasurements.length === 0 && (
            <li>{gettext("None have been configured, defaults will be used")}</li>
          )}
          {noMeasurements && <li>{gettext("Don't show any measurements from this machine")}</li>}
        </ul>

        <Modal
          className="modal-md dfi-modal"
          show={showModal}
          onHide={closeModal}
          data-backdrop={true}
        >
          <ModalHeader title={gettext("Select measurements")} />
          <Modal.Body>
            <div className="row">
              <div className="col-12 mb-1">
                <span>
                  {gettext(
                    "Select the measurements which should be displayed first in Cloudfarm for this machine"
                  )}
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col-12 mb-1">
                <span>
                  <input
                    className="mr-2"
                    type="checkbox"
                    id="checkbox_no_measurements"
                    checked={noMeasurements}
                    onChange={(e) => {
                      onChangeNoMeasurement(e.currentTarget.checked);
                    }}
                  />
                  <label htmlFor="checkbox_no_measurements">
                    {gettext("Don't show any measurements from this machine")}
                  </label>
                </span>
              </div>
              <div className="col-12">
                {!noMeasurements && (
                  <MultiSelect
                    disabled={false}
                    messages={{
                      searchPlaceholder: gettext("Search") + "...",
                      noItemsMessage: gettext("No Items") + "...",
                      noneSelectedMessage: gettext("None Selected"),
                      selectedMessage: gettext("selected"),
                      selectAllMessage: gettext("Select All"),
                      clearAllMessage: gettext("Clear All"),
                      disabledItemsTooltip: gettext("You can only select 1 file"),
                    }}
                    items={measurements}
                    selectedItems={selectedMeasurements}
                    onChange={(sortedList: SortedListData[]) => {
                      setSelectedMeasurements(sortedList);
                      onChange(sortedList.map((m) => m.id).join(","));
                    }}
                  />
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    )
  );
};

export default PriorityMeasurementsSelectModal;
